import React from "react";
import styled from "styled-components";
import colors from "../utils/colors";

const ContactSection = styled.section`
    padding: 6rem clamp(1rem, 4vw, 4rem) 4rem;
    width: 100%;
    background: ${colors.lightBackground};
`;

const ContactInner = styled.div`
    max-width: 1180px;
    margin: 0 auto;
    box-shadow: 0 1rem 2rem rgba(69, 90, 100, 0.16);
    border-radius: 0.9rem;
    overflow: hidden;
    display: flex;
    flex-wrap: wrap;
    background: ${colors.textColor};

    @media screen and (max-width:770px) {
        flex-direction: column;
    }
    `;
    
    const ContactLeft = styled.div`
    width: 50%;
    min-height: 28rem;

    iframe {
        width: 100%;
        height: 100%;
        min-height: 28rem;
        display: block;
    }

    @media screen and (max-width:770px) {
        width: 100%;
        min-height: 20rem;

        iframe {
            min-height: 20rem;
        }
    }
    `;
    
    const ContactForm = styled.div`
    padding: 3rem 2.5rem;
    width: 50%;
    
    @media screen and (max-width:770px) {
        width: 100%;
        padding: 2rem 1.5rem;
    }
`;

const ContactTitle = styled.h2`
    position: relative;
    font-size: 2rem;
    color: ${colors.darkBackground};
    font-weight: 600;
    line-height: 1.7rem;
    text-transform: capitalize;
    margin-bottom: 0.75rem;
    padding-bottom: 1.25rem;
    text-align: left;

    &:before {
        position: absolute;
        content: "";
        left: 0;
        bottom: 0;
        height: 0.1rem;
        width: 3rem;
        background: ${colors.primaryColor};
    }

    @media screen and (max-width:770px) {
        font-size: 1.6rem;
    }
`;

const ContactText = styled.p`
    font-size: 0.9rem;
    color: ${colors.darkColor};
    font-weight: 400;
    text-align: left;
    margin-bottom: 3rem;
`;

const ContactNotice = styled.p`
    padding: 0.85rem 1rem;
    margin: -1.5rem 0 1.5rem;
    border-radius: 0.55rem;
    font-size: 0.9rem;
    color: ${({ $type }) => ($type === "success" ? "#175b2f" : "#8a1f1f")};
    background: ${({ $type }) => ($type === "success" ? "#e8f6ee" : "#fdecec")};
    border: 0.06rem solid ${({ $type }) => ($type === "success" ? "#9bd5ad" : "#f2a8a8")};
`;

const ContactFormGroup = styled.div`
    margin-bottom: 1.4rem;
    display: block;

    @media screen and (max-width:770px) {
        flex-direction: column;
    }
`;

const FieldRow = styled.div`
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 1rem;

    @media screen and (max-width:770px) {
        grid-template-columns: 1fr;
    }
`;

const ContactInput = styled.input`
    flex: 1;
    height: 2.8rem;
    width: 100%;
    border: 0.06rem solid rgba(69, 90, 100, 0.35);
    text-transform: capitalize;
    padding: 0.6rem 1.1rem;
    color: ${colors.darkBackground};
    font-size: 0.8rem;
    font-weight: 400;
    border-radius: 0.55rem;
    outline: none;
    transition: border-color 0.25s ease, box-shadow 0.25s ease;

    &:focus {
        border-color: ${colors.primaryColor};
        box-shadow: 0 0 0 0.2rem rgba(241, 169, 96, 0.18);
    }

    @media screen and (max-width:770px) {
        width: 100%;
    }
`;

const ContactTextarea = styled.textarea`
    width: 100%;
    height: 6.25rem;
    border: 0.06rem solid rgba(69, 90, 100, 0.35);
    text-transform: capitalize;
    padding: 0.6875rem;
    color: #555;
    font-size: 0.875rem;
    font-weight: 400;
    border-radius: 0.55rem;
    outline: none;
    resize: vertical;
    transition: border-color 0.25s ease, box-shadow 0.25s ease;

    &:focus {
        border-color: ${colors.primaryColor};
        box-shadow: 0 0 0 0.2rem rgba(241, 169, 96, 0.18);
    }
`;

const ContactButton = styled.button`
    display: inline-block;
    color: ${colors.textColor};
    line-height: 1.5rem;
    min-width: 8rem;
    border: none;
    background-color: ${colors.background};
    border-radius: 999px;
    padding: 0.625rem 1rem;
    cursor: pointer;
    transition: background-color 0.25s ease, transform 0.25s ease;

    &:hover {
        background: ${colors.secondColor};
        transform: translateY(-0.1rem);
    }

    @media screen and (max-width:770px) {
        width: 100%;
    }
`;

const ContactInfoWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
    max-width: 1180px;
    margin: 1.5rem auto 0;

    @media screen and (max-width:770px) {
        padding: 0;
        margin: 0;
    }
`;

const SingleInfo = styled.div`
    background: ${colors.background};
    padding: 1.25rem 1.4rem;
    min-height: 6.4rem;
    flex: 1 1 16rem;
    margin: 0;
    border-radius: 0.8rem;
    position: relative;
    transition: all 0.3s ease-out;

    &:before {
        position: absolute;
        z-index: -1;
        content: "";
        bottom: -0.625rem;
        left: 0;
        right: 0;
        margin: 0 auto;
        width: 80%;
        height: 90%;
        background: ${colors.background};
        opacity: 0;
        filter: blur(0.6rem);
        transition: all 0.3s ease-out;
    }

    &:hover:before {
        opacity: 0.8;
    }

    &:hover {
        transform: translateY(-0.3125rem);
    }

    i {
        font-size: 2.5rem;
        color: ${colors.textColor};
        position: absolute;
        left: 2rem;
        font-size: 2rem;
    }

    .content {
        margin-left: 2.8rem;
    }

    h3 {
        color: ${colors.textColor};
        font-size: 1rem;
        font-weight: 600;
    }

    p {
        color: ${colors.textColor};
        margin-top: 0.5rem;
    }

    @media screen and (max-width:770px) {
        h3 {
            font-size: 0.8rem;
        }

        p{
            font-size: 0.8rem;
        }

        .content {
            margin-left: 1.82rem;
        }
    }
`;

function ContactUs() {
    const mailStatus = typeof window !== "undefined" ? new URLSearchParams(window.location.search).get("mail") : null;
    const notice =
        mailStatus === "sent"
            ? { type: "success", text: "Votre message a bien été envoyé." }
            : mailStatus
                ? { type: "error", text: "Le message n'a pas pu être envoyé. Veuillez vérifier les champs ou réessayer." }
                : null;

    return (
        <ContactSection>
            <>
                <ContactInner>
                    <ContactLeft>
                        <div>
                        <iframe 
                            title= "localisation-roms"
                            src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d1518.3379944184708!2d1.1938307538942328!3d6.181976685014253!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zNsKwMTAnNTYuOCJOIDHCsDExJzM4LjIiRQ!5e0!3m2!1sfr!2stg!4v1713993510865!5m2!1sfr!2stg" 
                            width="630" 
                            height="450"
                            style={{border:0}} 
                            allowFullScreen
                            loading="lazy" 
                            referrerPolicy="no-referrer-when-downgrade"
                        ></iframe>
                        </div>
                    </ContactLeft>
                    <ContactForm>
                        <ContactTitle>Contactez Nous</ContactTitle>
                        <ContactText>
                            Si vous avez des questions, n'hésitez pas à nous le faire savoir.
                        </ContactText>
                        {notice && <ContactNotice $type={notice.type}>{notice.text}</ContactNotice>}
                        {/* Form */}
                        <form className="form" method="post" action="/send-mail.php">
                            <div>
                                <input type="text" name="website" tabIndex="-1" autoComplete="off" style={{ display: "none" }} />
                                <ContactFormGroup>
                                    <FieldRow>
                                        <ContactInput type="text" name="name" placeholder="Nom" required />
                                        <ContactInput type="email" name="email" placeholder="Email" required />
                                    </FieldRow>
                                </ContactFormGroup>
                                <ContactFormGroup>
                                    <FieldRow>
                                        <ContactInput type="text" name="phone" placeholder="Téléphone" required />
                                        <ContactInput type="text" name="subject" placeholder="Sujet" />
                                    </FieldRow>
                                </ContactFormGroup>
                                <ContactFormGroup>
                                    <ContactTextarea name="message" placeholder="Message" required />
                                </ContactFormGroup>

                                <ContactFormGroup>
                                    <ContactButton type="submit">Envoyer</ContactButton>
                                </ContactFormGroup>
                            </div>
                        </form>
                    </ContactForm>
                </ContactInner>
                <ContactInfoWrapper>
                    <SingleInfo>
                        <i className="bi bi-telephone-outbound-fill"></i>
                        <div className="content">
                            <h3>+(228) 98 93 93 08</h3>
                            <h3>+(228) 90 99 01 33</h3>
                            <p>roms.service85@gmail.com</p>
                        </div>
                    </SingleInfo>
                    <SingleInfo className="single-info">
                        <i className="bi bi-geo-alt-fill"></i>
                        <div className="content">
                            <h3>Djidjolé, von face Hotêl Pesco</h3>
                            <p>Lomé, Togo</p>
                        </div>
                    </SingleInfo>
                    <SingleInfo className="single-info">
                        <i className="bi bi-stopwatch-fill"></i>
                        <div className="content">
                            <h3>Lun - Sam: 8h - 17h</h3>
                            <p>Dim: Fermé</p>
                        </div>
                    </SingleInfo>
                </ContactInfoWrapper>
            </>
        </ContactSection>
    )
}

export default ContactUs;
